const n = 864e5, t = ["narrow", "short", "long"], s = [0, 1, 6], c = [1, 2, 3, 4, 6, 12], C = 42, N = [0, 1], S = Symbol(), o = Symbol(), E = Symbol(), T = [E, o, S], R = Symbol(), _ = Symbol(), O = Symbol(), l = [_, O, R], A = Symbol(), L = Symbol(), b = Symbol(), m = Symbol(), y = Symbol(), I = Symbol(), D = Symbol(), M = Symbol(), U = Symbol(), F = Symbol(), K = Symbol(), W = Symbol(), B = Symbol(), H = Symbol(), Y = Symbol(), r = Symbol(), P = Symbol(), e = Symbol(), G = Symbol(), X = Symbol();
export {
  T as CALENDAR_CONTROLS,
  l as CALENDAR_SELECTIONS,
  S as CONTROLS_ALL,
  o as CONTROLS_MINIMAL,
  E as CONTROLS_NONE,
  A as CURSOR_BACKWARD,
  L as CURSOR_BLOCK_END,
  b as CURSOR_BLOCK_START,
  m as CURSOR_DOWNWARD,
  y as CURSOR_FORWARD,
  I as CURSOR_LINE_END,
  D as CURSOR_LINE_START,
  M as CURSOR_NEXT_BLOCK,
  U as CURSOR_PREV_BLOCK,
  F as CURSOR_UPWARD,
  n as DAY_MS,
  t as DAY_OF_WEEK_FORMATS,
  s as FIRST_WEEK_DAYS,
  c as FRAME_SIZES,
  C as MAXIMUM_MONTH_UNITS,
  K as RANGE_FROM,
  W as RANGE_TO,
  B as SELECTION_COLLAPSE,
  H as SELECTION_FARTHEST,
  Y as SELECTION_FROM,
  r as SELECTION_NEAREST,
  P as SELECTION_TO,
  R as SELECT_MANY,
  _ as SELECT_NONE,
  O as SELECT_ONE,
  e as SHIFT_BLOCK,
  G as SHIFT_FRAME,
  X as SHIFT_PERIOD,
  N as WEEKEND_DAYS_SEED
};
